import { importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { PAGE_VIEW_DATA_PROVIDER } from '@frontend/vanilla/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createMainCashierTranslateLoader } from '@payments/common-utils';

import { PaymentsPageViewDataProvider } from './tracking/payments-page-view-data-provider';

export function providePaymentsFeatures() {
    return [...providePaymentsProviders()];
}
export function providePaymentsProviders() {
    return [
        importProvidersFrom(
            MatDialogModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: createMainCashierTranslateLoader,
                },
            }),
        ),
        { provide: PAGE_VIEW_DATA_PROVIDER, useClass: PaymentsPageViewDataProvider, multi: true },
    ];
}
